import { render, staticRenderFns } from "./VendorPayments.vue?vue&type=template&id=014c0c2d&"
import script from "./VendorPayments.vue?vue&type=script&lang=js&"
export * from "./VendorPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports